import React from "react";
import "../css/container.css";
interface ClickableProps {
  backgroundUrl: string;
  children?: string | React.ReactNode;
  onclick: () => void;
  style?: string;
}

export const Clickable: React.FC<ClickableProps> = ({
  backgroundUrl,
  children,
  onclick,
  style,
}) => {
  const handleClick = () => {
    onclick(); // navigate to the URL
  };

  return (
    <div
      onClick={() => {
        handleClick();
      }}
      role="link"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleClick();
        }
      }}
      className={style !== undefined ? style : "clickable"}
      style={{
        backgroundImage: `url(${backgroundUrl})`,
      }}
    >
      {children}
    </div>
  );
};
